/* Product page sections (reference shop.html): main-product gallery/swatches/notify/add to cart,
   product-colours cards, and the accordions (Details… / Orders FAQ). Loaded by each product section; runs once. */
(function () {
  if (window.__dzProductJs) return;
  window.__dzProductJs = 1;

  var D = window.Dozzee || (window.Dozzee = {});
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* colours the visitor already signed up for on this page view: { 'cherry rush': 'email' } */
  var notified = (D.notifiedColours = D.notifiedColours || {});

  /* ---------- accordion: one open at a time, open row can be closed ---------- */
  function initAcc(root) {
    $$('[data-pp-acc]', root).forEach(function (acc) {
      if (acc._dz) return; acc._dz = 1;
      acc.addEventListener('click', function (e) {
        var b = e.target.closest('[data-acc-btn]');
        if (!b || !acc.contains(b)) return;
        var it = b.closest('[data-acc-item]'), open = !it.classList.contains('is-open');
        $$('[data-acc-item]', acc).forEach(function (x) {
          x.classList.remove('is-open');
          var xb = x.querySelector('[data-acc-btn]'); if (xb) xb.setAttribute('aria-expanded', 'false');
        });
        if (open) { it.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  function markNotified(detail) {
    var tags = String((detail && detail.tags) || '');
    (D.colours || []).forEach(function (c) {
      if (D.tagFor && tags.indexOf(D.tagFor(c)) > -1) notified[c.name.toLowerCase()] = detail.email || true;
    });
  }

  function scrollToEl(el, offset) {
    var top = el.getBoundingClientRect().top + window.scrollY - (offset || 0);
    if (D.lenis && D.lenis.scrollTo) D.lenis.scrollTo(top);
    else window.scrollTo({ top: top, behavior: D.reduce ? 'auto' : 'smooth' });
  }

  /* ---------- main product ---------- */
  function initMain(sec) {
    if (sec._dz) return; sec._dz = 1;
    var dataEl = sec.querySelector('[data-pp-data]');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cols = data.colours || [], variants = data.variants || [], S = data.strings || {};
    var srcId = 'product-' + sec.getAttribute('data-section-id');
    var sell = sec.getAttribute('data-sell') === 'true';

    var stage = sec.querySelector('[data-pp-stage]');
    var bands = $$('[data-pp-band]', sec), layers = $$('[data-pp-img]', sec), thumbs = $$('[data-pp-thumb]', sec);
    var thumbBand = sec.querySelector('[data-pp-thumb-band]');
    var swatches = $$('[data-pp-swatch]', sec);
    var nameEl = sec.querySelector('[data-pp-name]'), moodEl = sec.querySelector('[data-pp-mood]');
    var notifyWrap = sec.querySelector('[data-pp-notify]');
    var nf = notifyWrap && notifyWrap.querySelector('[data-notify]');
    var form = sec.querySelector('form[action*="/cart/add"]');
    var varInput = sec.querySelector('[data-pp-variant]');
    var addBtn = sec.querySelector('[data-pp-add]'), addLbl = sec.querySelector('[data-pp-add-label]');
    var added = sec.querySelector('[data-pp-added]'), errEl = sec.querySelector('[data-pp-error]');
    var priceEl = sec.querySelector('[data-pp-price]'), compareEl = sec.querySelector('[data-pp-compare]');
    var cur = -1;

    function themeColour(c) { return D.colourBy ? (D.colourBy(c.key) || D.colourBy(c.name)) : null; }
    function idxFor(colour) {
      if (!colour) return -1;
      for (var i = 0; i < cols.length; i++) {
        if ((cols[i].key && cols[i].key === colour.key) || cols[i].name.toLowerCase() === String(colour.name).toLowerCase()) return i;
      }
      return -1;
    }
    function variantById(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }

    function setImg(n) {
      layers.forEach(function (l) { l.classList.toggle('is-on', +l.getAttribute('data-pp-img') === n); });
      thumbs.forEach(function (t) {
        var on = +t.getAttribute('data-pp-thumb') === n;
        t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function showDone(email) {
      if (!nf) return;
      $$('[data-email]', nf).forEach(function (el) { el.textContent = email === true ? '' : email; });
      var f = nf.querySelector('form'), d = nf.querySelector('[data-notify-done]'), er = nf.querySelector('[data-notify-error]');
      if (f) f.hidden = true; if (d) d.hidden = false; if (er) er.hidden = true;
      nf.classList.add('is-done');
    }

    function updateVariant(v, pushUrl) {
      if (!v) return;
      if (varInput && String(varInput.value) !== String(v.id)) varInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLbl) addLbl.textContent = v.available ? S.add : S.soldOut;
      }
      // sold-out variants fall back to the Notify form
      if (notifyWrap) notifyWrap.hidden = !!v.available;
      if (priceEl && v.price) priceEl.textContent = v.price;
      if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
      if (pushUrl && data.fromVariants && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }
    }

    function select(i, pushUrl) {
      if (i < 0 || i >= cols.length) return;
      var c = cols[i]; cur = i;
      if (stage) stage.style.backgroundColor = c.tint;
      bands.forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-pp-band') === i); });
      if (thumbBand && c.band) thumbBand.src = c.band;
      swatches.forEach(function (s) { s.setAttribute('aria-pressed', +s.getAttribute('data-pp-swatch') === i ? 'true' : 'false'); });
      var tc = themeColour(c);
      if (nameEl) nameEl.textContent = c.name;
      if (moodEl) moodEl.textContent = tc && tc.mood ? ' · ' + tc.mood : '';

      // Notify form follows the colour: tags, success copy, one sign-up per colour (like the reference)
      if (nf) {
        var tag = tc && D.tagFor ? D.tagFor(tc) : 'notify-' + c.name.toLowerCase().replace(/\s+/g, '-');
        if (D.setNotifyTags) D.setNotifyTags(nf, 'launch-list,' + tag);
        $$('[data-colour-name]', nf).forEach(function (el) { el.textContent = c.name; });
        var em = notified[c.name.toLowerCase()];
        if (em) showDone(em); else if (D.resetNotify) D.resetNotify(nf);
      }

      if (sell) {
        var v = null;
        if (data.fromVariants) v = variantById(c.variantId);
        if (!v && varInput) v = variantById(varInput.value);
        if (!v) v = variants[0];
        updateVariant(v, pushUrl);
      }
    }

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        var i = +s.getAttribute('data-pp-swatch');
        select(i, true);
        var tc = themeColour(cols[i]);
        if (tc && D.setColour) D.setColour(tc.key, srcId);
        if (added) added.hidden = true;
      });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setImg(+t.getAttribute('data-pp-thumb')); });
    });

    // full variant <select> (products with extra options)
    if (varInput && varInput.tagName === 'SELECT') {
      varInput.addEventListener('change', function () {
        var v = variantById(varInput.value);
        if (v && v.c > -1 && v.c !== cur) {
          select(v.c, false);
          var tc = themeColour(cols[v.c]); if (tc && D.setColour) D.setColour(tc.key, srcId);
        }
        updateVariant(v, true);
      });
    }

    // colour picked elsewhere (colour cards, other pickers)
    document.addEventListener('dozzee:colour', function (e) {
      var d = e.detail || {};
      if (d.source === srcId || !document.body.contains(sec)) return;
      var i = idxFor(d.colour);
      if (i < 0) return;
      select(i, true);
      if (d.source === 'product-colours') setImg(0);
    });

    if (nf) {
      nf.addEventListener('dozzee:notified', function (e) {
        if (cur > -1) notified[cols[cur].name.toLowerCase()] = (e.detail && e.detail.email) || true;
      });
    }

    // Add to cart via AJAX, falling back to a normal form submit
    if (form && sell) {
      form.addEventListener('submit', function (e) {
        if (!D.addToCart || !varInput) return;
        e.preventDefault();
        if (addBtn) { addBtn.classList.add('is-busy'); addBtn.disabled = true; }
        if (errEl) errEl.hidden = true;
        D.addToCart(varInput.value, 1)
          .then(function () {
            if (added) { added.hidden = false; clearTimeout(added._t); added._t = setTimeout(function () { added.hidden = true; }, 5000); }
            if (addBtn) { addBtn.classList.remove('is-busy'); addBtn.disabled = false; }
          })
          .catch(function () { form.submit(); });
      });
    }

    // start colour: ?variant= / product named after a colour wins, else the remembered colour
    var start = data.selected || 0;
    if (!data.lock && D.getColour) {
      var k = idxFor(D.getColour());
      if (k > -1) start = k;
    }
    select(start, false);
    if (data.lock) {
      var tc0 = themeColour(cols[start]);
      if (tc0 && D.setColour) D.setColour(tc0.key, srcId);
    }
    setImg(0);
  }

  /* ---------- colour cards ---------- */
  function initCards(sec) {
    if (sec._dz) return; sec._dz = 1;
    var S = {};
    try { S = JSON.parse((sec.querySelector('[data-pc-strings]') || {}).textContent || '{}'); } catch (e) {}
    function labels() {
      $$('[data-pc-pick]', sec).forEach(function (b) {
        var c = D.colourBy && D.colourBy(b.getAttribute('data-pc-pick')), l = b.querySelector('[data-pc-label]');
        if (c && l) l.textContent = notified[c.name.toLowerCase()] ? S.onList : S.notify;
      });
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pc-pick]');
      if (!b) return;
      var key = b.getAttribute('data-pc-pick');
      if (D.setColour) D.setColour(key, 'product-colours');
      var main = document.querySelector('[data-section-type="main-product"]');
      if (main) scrollToEl(main, 90);
      else if (D.product) window.location.href = D.product + '#notify';
    });
    document.addEventListener('dozzee:notified', function () { setTimeout(labels, 0); });
    labels();
  }

  document.addEventListener('dozzee:notified', function (e) { markNotified(e.detail); });

  function init(root) {
    $$('[data-section-type="main-product"]', root).forEach(initMain);
    $$('[data-section-type="product-colours"]', root).forEach(initCards);
    initAcc(root);
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
